import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FLXLabelComponent } from './label/label.component';

@NgModule({
	imports: [CommonModule],
	declarations: [FLXLabelComponent],
	exports: [FLXLabelComponent]
})
export class FLXLabelsModule {}
